import useSystemStore from "@store/useSystemStore";
import { useDebounce } from "@hooks/useDebounce";
import { useChromeInitialization } from "./hooks/useChromeInitialization";
import { ActiveScreen } from "@enums/screens.enum";
import { ItemType } from "@enums/common.enum";
import ConnectionIssueScreen from "@screens/connection-issue";
import EmailMismatchScreen from "@screens/email-mismatch";
import GetOutlookAddinScreen from "@screens/get-outlook-addin";
import OpenGoogleItemScreen from "@screens/open-google-item";
import LoginScreen from "@screens/login-with-meridian";
import CompanyScreen from "@screens/company";
import { TransitionWrapper } from "@ui/Transition";
import { AppLoader } from "@ui/Loaders";

export function ChromeScreenManager() {
  useChromeInitialization();

  const { isAppLoading, isAppOffline, activeScreen } = useSystemStore();
  const debouncedIsOffline = useDebounce(isAppOffline, 500);

  if (debouncedIsOffline) return <ConnectionIssueScreen isVisible={isAppOffline} />;

  if (isAppLoading) return <AppLoader />;

  const getScreen = () => {
    switch (activeScreen) {
      case ActiveScreen.LOADING:
        return <AppLoader />;
      case ActiveScreen.LOGIN:
        return <LoginScreen />;
      case ActiveScreen.COMPANY:
        return <CompanyScreen />;
      case ActiveScreen.GOOGLE_MAIL:
        return <OpenGoogleItemScreen itemType={ItemType.EMAIL} />;
      case ActiveScreen.GOOGLE_CALENDAR:
        return <OpenGoogleItemScreen itemType={ItemType.MEETING} />;
      case ActiveScreen.EMAIL_MISMATCH:
        return <EmailMismatchScreen />;
      case ActiveScreen.GET_OUTLOOK_ADDIN:
        return <GetOutlookAddinScreen />;
      default:
        return <AppLoader />;
    }
  };

  return <TransitionWrapper screenKey={activeScreen}>{getScreen()}</TransitionWrapper>;
}
